export default __webpack_public_path__ + "static/media/blog-img82.b807d5ec.jpg";